import { Moment } from 'moment';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { status } from './status';

interface Props extends ClassNamePropsWithChildren {
  timestamp: Moment;
  completed?: boolean;
}

const Wrapper = styled.span`
  --due-date-default-color: initial;
  --due-date-attention-color: var(--yellow-60);
  --due-date-overdue-color: var(--error-color);

  color: var(---due-date-default-color);
  width: 100%;
`;

const Date: FC<Props> = ({ className, timestamp }) => (
  <Wrapper className={className}>
    <HumanisedDate timestamp={timestamp} />
  </Wrapper>
);

export const DueDate = styled(Date)<Props>`
  ${({ timestamp, completed }) =>
    !completed &&
    css`
      color: var(--due-date-${status(timestamp)}-color);
    `};
`;
